import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { KeyRound, ArrowLeft } from "lucide-react";
import { API, formatApiError } from "@/lib/api";
import Seo from "@/components/Seo";

export default function StudioLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await API.post("/auth/login", form);
      navigate("/studio");
    } catch (err) {
      setError(formatApiError(err, "Login failed."));
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full bg-paper border border-ink/15 rounded-md px-4 py-3.5 text-sm text-ink placeholder:text-subtle focus:outline-none focus:border-terracotta/60 transition-colors";

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-5 py-24" data-testid="studio-login-page">
      <Seo title="Studio Entrance" />
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-stone2 hover:text-terracotta transition-colors mb-8">
          <ArrowLeft size={12} /> Back to the gallery
        </Link>
        <div className="bg-paper border border-ink/10 deckle p-8 sm:p-10">
          <KeyRound size={22} className="text-terracotta" />
          <h1 className="font-serif text-3xl text-ink mt-4">The Studio Door</h1>
          <p className="text-sm text-stone2 mt-2">For Richard only — inventory, inquiries and orders beyond this point.</p>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <input data-testid="admin-login-email-input" required type="email" placeholder="Studio email"
              value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={field} />
            <input data-testid="admin-login-password-input" required type="password" placeholder="Passphrase"
              value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className={field} />
            {error && <p className="text-sm text-destructive" data-testid="admin-login-error">{error}</p>}
            <button data-testid="admin-login-submit-btn" disabled={loading} type="submit"
              className="w-full bg-ink text-linen rounded-full py-3.5 text-xs font-mono uppercase tracking-[0.2em] hover:bg-terracotta transition-colors duration-300 disabled:opacity-60">
              {loading ? "Unlocking…" : "Enter the Studio"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
